export const headersSubtiposDominio = [
  { text: '', width: 1, key: 'offCanvas' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 5, key: 'status' },
  { text: 'Ordem', width: 4, key: 'ordem' },
  { text: 'Nome do Subtipo', width: 12, key: 'dominioSubtipo' },
  { text: 'Descrição', width: 20, key: 'descricao' },
];

export const valoresExibidosSubtiposDominio: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Data de Registro',
  dataAtualizacao: 'Última Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  dataUltimaAtualizacao: 'Última Atualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  usuarioRegistro: 'Responsável pelo Registro',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  observacoes: 'Observações',

  // Domínio Tipo
  status: 'Status',
  ordem: 'Ordem',
  dominioSubtipo: 'Nome do Subtipo',
  descricao: 'Descrição',
  corId: 'ID da Cor',
  corCodigo: 'Código da Cor',
  corNome: 'Nome da Cor',
  corText: 'Cor do Texto',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorCores: '',
  separadorObservacoes: '',
};

export const fieldObject = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
